import { FC } from 'react';
import { NotificationsAssignments } from './NotificationsAssignments';
import { NotificationsAssignmentsMeetings } from './NotificationsAssignmentsMeetings';
import { typeMeeting } from '@monorepo/models';

type propsType = {
    meetings: typeMeeting[];
};

export const NotificationsMeetingAVUshers: FC<propsType> = ({ meetings }) => {
    
    return (
        <NotificationsAssignments
            content={!!meetings.length ?
                meetings.map(m =>
                    <NotificationsAssignmentsMeetings key={m.id}
                        content={
                            [...m.avAssignments, ...m.usherAssignments].filter(a => a.user).map(a =>
                                <li key={`${m.id}_${a.name}`} className={'mt-2'}>
                                    <span className={'fw-bold'}>
                                        {a.name}: {a.user!.name} {a.user!.lastName} | {a.user!.phoneNumber ? <span className={'bg-success'}>Teléfono: {a.user!.phoneNumber}</span> : <span className={'bg-general-red'}>Sin teléfono cargado - No recibirá notificaciones</span>}
                                    </span>
                                </li>
                            )
                        }
                        meeting={m}
                    />
                )
                :
                <>No hay ninguna asignación</>
            }
        />
    );
}
